export enum PortfolioChildType {
	MODEL_PORTFOLIO = 'MODEL_PORTFOLIO',
	THIRD_PARTY = 'THIRD_PARTY',
	USER_PORTFOLIO = 'USER_PORTFOLIO',
	HOLDING = 'SECURITY_ID',
	ALTS_HOLDING = 'ALTS_HOLDING',
	PUBLIC_SMA = 'PUBLIC_SMA',
}
